export default [
	{
		code: 'industrial',
		name: 'Industrial',
	},
	{
		code: 'apartments',
		name: 'Multi-Family',
	},
	{
		code: 'office',
		name: 'Office',
	},
	{
		code: 'retail',
		name: 'Retail',
	},
	{
		code: 'other',
		name: 'Other',
	},
]